import api from "../../../api"

export function utmApi(payload){
    return api.post("utm-report", payload)
}